<template>
  <div>
    <TitleSlot title="商品推荐" :showMore="false"></TitleSlot>
    <div class="wrapper" :class="{'change-pos': params['params' + currentIndex].align == 'right'}">
      <ul class="l" >
        
        <li v-for="(item,index) in params['params' + currentIndex].imgs" :key="index" :class="params['params' + currentIndex].imgs.length == 1 ? 'one' : 'two' ">
          <a href="javascript:;" @click="itemClick(item)">
            <img :src="item.image" alt>
          </a>
        </li>
      </ul>
      <div class="r">
        <LoftRow :row="params['params' + currentIndex].imgs.length==0?'':'row-4'" :list="params['params' + currentIndex].list" :nums="nums"></LoftRow>
      </div>
    </div>


    <template v-if="params.totalPage">
      <Pagination :totalPage="params.totalPage" :limit="10" @changePage="handOrderMore"></Pagination>
    </template>
  </div>
</template>

<script>
import TitleSlot from "@/components/home/TitleSlot.vue";
import LoftRow from "./LoftRow.vue";
import Pagination from "@/components/common/Pagination.vue";

import {linkCommon } from '@/utils/index.js'

export default {
  name: "ProductLoft",
  components: { TitleSlot, LoftRow, Pagination },
  props: {
    headTitle: {
      type: String,
      default: ""
    },
    params: {
        type: [Object, Array]
    },
    list: {
      type: Array,
      default: function() {
        return [];
      }
    },
    advLeft: {
      type: Array,
      default: function() {
        return [];
      }
    },
    keyword: {
      type: String,
      default: ""
    },
    nums: {
      type: [Number, String],
      default: -1
    }
  },
  computed: {
    slotArr() {
      return this.keyword.split(" ");
    }
  },
  data() {
    return {
      currentIndex: 0
    };
  },
  methods: {
    handOrderMore(e) {
      this.currentIndex = e - 1
      console.log(e)
    },
    itemClick(v) {
      linkCommon(v, this)
    },
  }
};
</script>
<style lang="scss" scoped>
@import "~@/assets/css/variable.scss";
.page-box{
  padding: 10px 0;
}
.wrapper {
  display: flex;
  justify-content: space-between;
  align-content: space-between;
  height: 628px;
  overflow: hidden;
  // background: #f5f5f5;
  &.change-pos{
    flex-direction: row-reverse;
    .l{
      margin-left: 14px;
      margin-right: 0;
    }
  }
  .l {
    width: 234px;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    margin-bottom: 14px;
    margin-right: 14px;
    li {
      &.one {
        height: 100%;
      }
      &.two {
        height: 300px;
      }
      a {
        display: block;
        width: 234px;
        height: 100%;
        transition: all 0.25s;
        &:hover {
          transform: translateY(-3px);
          box-shadow: 1px 1px 20px #999;
        }
        img {
          display: block;
          width: 100%;
          height: 100%;
          object-fit: cover;
        }
      }
    }
  }
  .r {
    flex: 1;
    overflow: hidden;
  }
}
</style>